import { useCompanyLinksStore } from '@app/application/company_links/store/use-company-links'
import type { ExistingCompanyLink } from '@app/application/company_links/types.ts'

import { makePageSingleton } from '@app/adapters/singleton/page'

class CompanyLinksService {
  #existingCompanyLinks: ExistingCompanyLink[] | null = null

  fetchExistingCompanyLinks = async (): Promise<ExistingCompanyLink[]> => {
    // If we already have the existing company links cached, return them
    if (this.#existingCompanyLinks) {
      return this.#existingCompanyLinks
    }

    const companyLinksStore = useCompanyLinksStore()

    if (!companyLinksStore.initialized) {
      await companyLinksStore.initExistingCompanyLinks()
    }

    this.#existingCompanyLinks = companyLinksStore.existingCompanyLinks

    return this.#existingCompanyLinks
  }

  teardown = (): void => {
    this.#existingCompanyLinks = null
  }
}

export default makePageSingleton(() => new CompanyLinksService())
